import { useI18n } from 'builder/hooks/useI18n'
import { Skeleton } from 'builder/Skeleton/Skeleton'
import { Interview, InterviewAnswerFeedback } from 'builder/modules/interview/types'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { ShowStyledHTML } from '../ShowStyledHTML/ShowStyledHTML'
import BlurredTextBlock from '../../assets/blurredTextBlock.png'
import {
  Body,
  Title,
  HeaderContainer,
  IdealContent,
  IdealBoldContent,
  BodyContainer,
  FutureEmploysSays,
  ContainerWithoutPaywall,
  ContainerWithPaywall,
} from './styles'
import { Paywall } from './components/Paywall/Paywall'

export const TRANSLATION_PREFIX = `builder.interview_prep_view.feedbackV2.ideal_answer_section`

interface Props {
  feedback: InterviewAnswerFeedback | undefined
  interview: Interview | undefined
  enablePaywall: boolean
}

const IdealAnswerSectionBase = ({ feedback, interview, enablePaywall }: Props) => {
  const { i18n } = useI18n()

  const isLoading = !feedback?.ideal_answer
  const { isPhone } = useMediaQueries()

  return (
    <>
      <HeaderContainer>
        {isLoading ? (
          <Skeleton width={209} height={20} />
        ) : (
          <Title>{i18n.t(`${TRANSLATION_PREFIX}.ideal_answer`)}</Title>
        )}

        {enablePaywall && !isPhone && (
          <>
            {isLoading || !interview ? (
              <Skeleton width={331} height={20} />
            ) : (
              <IdealContent>
                {i18n.t(`${TRANSLATION_PREFIX}.ideal_header_content_1`)}
                <IdealBoldContent>
                  {Math.abs(feedback?.words_per_minute - 150) > 10 &&
                    i18n.t(`${TRANSLATION_PREFIX}.ideal_header_content_2`, {
                      wpm: feedback?.words_per_minute,
                    })}
                </IdealBoldContent>
                <span>{i18n.t(`${TRANSLATION_PREFIX}.ideal_header_content_3`)}</span>
              </IdealContent>
            )}
          </>
        )}
      </HeaderContainer>

      <BodyContainer>
        {isLoading || !interview ? (
          <div>
            <Skeleton width={781} height={20} />
            <Skeleton width={781} height={20} style={{ marginTop: '4px' }} />
          </div>
        ) : (
          <FutureEmploysSays>
            {i18n.t(`${TRANSLATION_PREFIX}.future_employees_says`, {
              companyName: interview.company_name || '',
            })}
          </FutureEmploysSays>
        )}

        <Body>
          {isLoading || !interview ? (
            <div>
              <Skeleton width={781} height={20} />
              <Skeleton width={781} height={20} style={{ marginTop: '4px' }} />
              <Skeleton width={576} height={20} style={{ marginTop: '4px' }} />
              <Skeleton width={807} height={20} style={{ marginTop: '28px' }} />
              <Skeleton width={807} height={20} style={{ marginTop: '4px' }} />
              <Skeleton width={807} height={20} style={{ marginTop: '4px' }} />
              <Skeleton width={782} height={20} style={{ marginTop: '4px' }} />
            </div>
          ) : !enablePaywall ? (
            <ShowStyledHTML dangerouslySetInnerHTML={{ __html: feedback.ideal_answer }} />
          ) : (
            <>
              <ShowStyledHTML
                dangerouslySetInnerHTML={{
                  __html: `${feedback.ideal_answer.substring(
                    0,
                    feedback.ideal_answer.length / 3,
                  )}...`,
                }}
              />
              <img src={BlurredTextBlock} width="100%" height="100%"></img>
            </>
          )}
        </Body>
      </BodyContainer>
    </>
  )
}

export const IdealAnswerSection = (props: Props) => {
  if (props.enablePaywall) {
    return (
      <Paywall interview={props.interview}>
        <ContainerWithPaywall>
          <IdealAnswerSectionBase {...props} />
        </ContainerWithPaywall>
      </Paywall>
    )
  }

  return (
    <ContainerWithoutPaywall>
      <IdealAnswerSectionBase {...props} />
    </ContainerWithoutPaywall>
  )
}
